import i18n from "@/i18n";

export enum VideoConferenceProvider {
  Webex = 1,
  Zoom,
  Teams,
  GoogleMeet,
  GoToMeeting,
  BlueJeans,
  Lifesize,
  LogMeIn,
  Skype,
  CollaborateSpace,
  Jitsi = 16,
}

export interface WebExAuthData {
  userAuthenticationCode: string;
  userAccessToken: string;
  userAccessTokenExpiration: number;
  userRefreshToken: string;
}

export interface TeamsAuthData {
  refresh_token: string;
}

export interface GoogleMeetAuthData {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  scope: string;
  id_token: string;
  first_issued_at: number;
  expires_at: number;
  calendarId: string;
  calendarName: string;
}

export interface VideoConferenceAuthenticationRequest {
  videoConferenceType: VideoConferenceProvider;
  enabled: boolean;
  videoConferenceToken?: WebExAuthData | TeamsAuthData | GoogleMeetAuthData;
}

export interface VideoConferenceSystem {
  id: string;
  provider: VideoConferenceProvider;
  value: string; // used in AV policy as select option
  name: string;
  icon: string;
  enabled: boolean;
  conferenceType: number;
}

export const VIDEO_CONFERENCE_SYSTEMS: Array<VideoConferenceSystem> = [
  {
    id: "jitsi",
    provider: VideoConferenceProvider.Jitsi,
    value: "Mago Meet",
    name: i18n.t("common.magoMeet") as string,
    icon: require("@/assets/images/av/mago-meet.png"),
    enabled: true,
    conferenceType: 16,
  },
  {
    id: "teams",
    provider: VideoConferenceProvider.Teams,
    value: "Teams",
    name: i18n.t("common.microsoftTeams") as string,
    icon: require("@/assets/images/av/microsoft-teams.png"),
    enabled: true,
    conferenceType: 6,
  },
  {
    id: "zoom",
    provider: VideoConferenceProvider.Zoom,
    value: "Zoom",
    name: i18n.t("common.zoom") as string,
    icon: require("@/assets/images/av/zoom.png"),
    enabled: true,
    conferenceType: 8,
  },
  {
    id: "google-meet",
    provider: VideoConferenceProvider.GoogleMeet,
    value: "GoogleMeet",
    name: i18n.t("common.googleMeet") as string,
    icon: require("@/assets/images/av/google-meet.png"),
    enabled: true,
    conferenceType: 1,
  },
  {
    id: "webex",
    provider: VideoConferenceProvider.Webex,
    value: "CiscoWebEx",
    name: i18n.t("common.ciscoWebEx") as string,
    icon: require("@/assets/images/av/cisco-webex.png"),
    enabled: true,
    conferenceType: 0,
  },
  {
    id: "GoToMeeting",
    provider: VideoConferenceProvider.GoToMeeting,
    value: "GoToMeeting",
    name: i18n.t("common.goToMeeting") as string,
    icon: require("@/assets/images/av/goto-meeting.jpeg"),
    enabled: false,
    conferenceType: 2,
  },
  {
    id: "BlueJeans",
    provider: VideoConferenceProvider.BlueJeans,
    value: "BlueJeans",
    name: i18n.t("common.blueJeans") as string,
    icon: require("@/assets/images/av/blue-jeans.png"),
    enabled: false,
    conferenceType: 10,
  },
  {
    id: "Lifesize",
    provider: VideoConferenceProvider.Lifesize,
    value: "Lifesize",
    name: i18n.t("common.lifeSize") as string,
    icon: require("@/assets/images/av/lifesize.jpeg"),
    enabled: false,
    conferenceType: 5,
  },
  {
    id: "JoinMe",
    provider: VideoConferenceProvider.LogMeIn,
    value: "JoinMe",
    name: i18n.t("common.logMeIn") as string,
    icon: require("@/assets/images/av/join-me.png"),
    enabled: false,
    conferenceType: 4,
  },
  {
    id: "ClearOneCollabSpace",
    provider: VideoConferenceProvider.CollaborateSpace,
    value: "ClearOneCollabSpace",
    name: i18n.t("common.clearOneCollabSpace") as string,
    icon: require("@/assets/images/av/collaborate-space.png"),
    enabled: false,
    conferenceType: 11,
  },
];

//  [Description("Cisco WebEx")] CiscoWebEx = 0,
//  [Description("Google Meet")] GoogleMeet = 1,
//  [Description("GoToMeeting")] GoToMeeting = 2,
//  [Description("ConX Meeting")] InFocusConX = 3,
//  [Description("Join.Me")] JoinMe = 4,
//  [Description("Lifesize")] Lifesize = 5,
//  [Description("Microsoft Teams")] Teams = 6,
//  [Description("Skype for Business")] SkypeForBusiness = 7,
//  [Description("Zoom")] Zoom = 8,
//  [Description("Valarea")] Valarea = 9,
//  [Description("Bluejeans")] BlueJeans = 10,
//  [Description("COLLABORATE® Space")] ClearOneCollabSpace = 11,
//  [Description("Cisco Jabber Sber")] CiscoJabberSber = 12,
//  [Description("Jazz Sber")] JazzSber = 13,
//  [Description("Other/unknown")] Other = 14,
//  [Description("TrueConf")] TrueConf = 15,
//  [Description("Mago Meet")] Jitsi = 16
